import axios, { AxiosResponse } from "axios";
import { Extra } from "../objects/Extra";

export const getExtrasListDefinition = (client_id: number): Promise<AxiosResponse<Extra[]>> => axios.get(
    `${API_HREF}client/${client_id}/extra-definitions/`,
    {
        headers: {
            'Authorization': `Token ${localStorage.getItem('token')}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        },
    },
);

export const addExtraListDefinition = (client_id: number, data: Extra): Promise<AxiosResponse<Extra>> => axios.post(
    `${API_HREF}client/${client_id}/extra-definitions/`,
    {
        label: data.label,
        reference: data.reference
    },
    {
        headers: {
            'Authorization': `Token ${localStorage.getItem('token')}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        },
    },
);

export const patchExtraListDefinition = (client_id: number, data: Extra): Promise<AxiosResponse<Extra>> => axios.patch(
    `${API_HREF}client/${client_id}/extra-definitions/${data.id}/`,
    {
        label: data.label,
        reference: data.reference
    },
    {
        headers: {
            'Authorization': `Token ${localStorage.getItem('token')}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        },
    },
);
export const deleteExtraListDefinition = (client_id: number, data: Extra): Promise<AxiosResponse<Extra>> => axios.delete(
    `${API_HREF}client/${client_id}/extra-definitions/${data.id}/`,
    {
        headers: {
            'Authorization': `Token ${localStorage.getItem('token')}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        },
    },
);